import React, { useEffect, useState, useCallback } from 'react';

import { Auth } from 'aws-amplify';
import Axios from 'axios';
import { API_ROUTES } from 'src/config/api';
import { Spinner } from "reactstrap";
import Skeleton from 'react-loading-skeleton'

import 'react-loading-skeleton/dist/skeleton.css'

const OrganisationFeatures = ({ organisation }) => {
  const [loading, setLoading] = useState(true);
  const [roles, setRoles] = useState([]);

  const getRoles = useCallback(async (triggerLoading = true) => {
    if (triggerLoading || roles.length === 0) {
      setLoading(true);
    }

    const user = await Auth.currentAuthenticatedUser();

    const result = await Axios(
      API_ROUTES.user['organisation:feature'](organisation.organisation),
      {
        method: 'get',
        headers: { Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}` },
      }
    );

    setRoles(result.data.data.map((item) => ({
      ...item,
      changing: false,
    })));
    setLoading(false);
  }, [organisation.organisation]);

  useEffect(() => {
    getRoles();
  }, [getRoles]);

  const changeStatus = async (organisationID, key, status) => {
    let data = [...roles];
    data[key].changing = true;
    setRoles(data);

    const user = await Auth.currentAuthenticatedUser();
    const action = status === true ? 'add' : 'remove';

    await Axios.post(
      API_ROUTES.user["organisation:feature:change"](organisationID, action),
      JSON.stringify({
        'feature-id': data[key].id,
      }),
      {
        headers: {
          Authorization: `Bearer ${user.signInUserSession.idToken.jwtToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

    data = [...roles];
    data[key].enabled = status;
    data[key].changing = false;
    setRoles(data);
  }

  return (

    <div>

<h3 className="font-extralight uppercase font-mono text-2xl dark:text-white text-violet-900 mb-4 border-b border-violet-900 pb-2">
          Features
        </h3>


      <div>
        {loading === true && (
          <Skeleton count={5} height="50px" className="mt-4" style={{
            width: '100%',
          }} />
        )}
        {loading === false && (
          <React.Fragment>
            <table className="table-auto w-full divide-y divide-gray-200">
              <tbody className='divide-y divide-gray-200'>
                {
                  roles.map((item, key) => {
                    return (
                      <tr>
                        <td className='py-4 pr-4'>
                          <strong className='text-violet-800'>{item.name}</strong> <br />
                          {item.description}
                        </td>
                        <td>
                          <div className="custom-control custom-switch float-right  pr-0 mr-0">
                            <span>{item.changing && <Spinner size="sm" className="mt-1 mr-3"> </Spinner>}</span>
                            <input
                              type="checkbox"
                              className="custom-control-input form-control"
                              checked={item.enabled}
                              disabled={item.changing}
                              onChange={() => changeStatus(organisation.organisation, key, item.enabled === false)}
                              id={`feature-switch-${item.id}`}
                            />
                            <label className="custom-control-label" htmlFor={`feature-switch-${item.id}`} />
                          </div>
                        </td>
                      </tr>
                    );
                  })
                }
              </tbody>
            </table>
          </React.Fragment>
        )}
      </div>
    </div>
  );
};
export default OrganisationFeatures;

/*
                      <Col size="4" key={key}>
                        <Card className="card-bordered mb-0 pb-o">
                          <CardHeader className="bg-light text-primary fw-bolder pr-0">
                            <div className="custom-control custom-switch float-right  pr-0 mr-0">
                              <span>{item.changing && <Spinner size="sm" className="mt-1 mr-3"> </Spinner>}</span>
                              <input
                                type="checkbox"
                                className="custom-control-input form-control"
                                checked={item.enabled}
                                disabled={item.changing}
                                onChange={() => changeStatus(organisation.organisation, key, item.enabled === false)}
                                id={`feature-switch-${item.id}`}
                              />
                              <label className="custom-control-label" htmlFor={`feature-switch-${item.id}`} />
                            </div>
                            {item.name}
                            {
                              item.is_beta === true && (
                                <Badge color="primary" className="ml-1 text-white">Beta</Badge>
                              )
                            }
                          </CardHeader>
                          <CardBody className="card-inner pt-2 pb-2">
                            {item.description}
                          </CardBody>
                        </Card>
                      </Col>
                      */